import { useSelector } from "react-redux";
import useMovieTrailer from "../hooks/useMovietrailer";

const VideoBackground = (props) => {
  const { movieId } = props;
  useMovieTrailer(movieId);
  const trailerId = useSelector((store) => store.movies?.movieTrailer);

  return (
    <div >
      <iframe
      className="w-screen aspect-video"
        src={
          "https://www.youtube.com/embed/" +
          trailerId?.key +
          "?si=w996CL6n7xNGJsUW&autoplay=1&mute=1&loop=1"
        }
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
      ></iframe>
    </div>
  );
};

export default VideoBackground;
